import React from 'react';
import { GOOGLE_CLIENT_ID, GOOGLE_REDIRECT_URI, GOOGLE_SCOPES } from '../../config/api';

const GoogleLogin = ({ onSuccess, onFailure }) => {
  const handleGoogleLogin = () => {
    console.log('Google login clicked');

    // Build Google OAuth URL with redirect method
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${GOOGLE_CLIENT_ID}&` +
      `redirect_uri=${encodeURIComponent(GOOGLE_REDIRECT_URI)}&` +
      `scope=${encodeURIComponent(GOOGLE_SCOPES)}&` +
      `response_type=code&` +
      `access_type=offline&` +
      `prompt=consent`;

    console.log('Redirecting to Google OAuth:', googleAuthUrl);
    
    // Redirect to Google OAuth
    window.location.href = googleAuthUrl;
  };

  return (
    <button
      type="button"
      className="social-login-btn google-login-btn"
      onClick={handleGoogleLogin}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 24px',
        backgroundColor: '#fff',
        border: '1px solid #dadce0',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        color: '#3c4043',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        width: '100%',
        marginBottom: '8px',
        /* [CF 2026-08-17] Client: "the G should be on the left". The button is a
           flex row of icon-then-text, so on the Arabic site the whole row
           mirrored and the G ended up on the right. Pinning the button itself
           to LTR keeps Google's mark on the leading edge in both languages —
           which is also what Google's own branding requires — without touching
           the page direction around it. */
        direction: 'ltr'
      }}
      onMouseOver={(e) => {
        e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
      }}
      onMouseOut={(e) => {
        e.target.style.boxShadow = 'none';
      }}
    >
      <svg 
        className="social-icon" 
        viewBox="0 0 24 24" 
        width="20" 
        height="20"
        style={{ marginRight: '12px' }}
      >
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
      <span className="social-text">Continue with Google</span>
    </button>
  );
};

export default GoogleLogin;
